<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/why0zz/tc-custom/9781468306132.jpg?1734323332537" alt="This image is the cover for the book Sister Teresa"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sister Teresa
      </h1>
      <p class="bookDescription body article font2">
        <b>“This brilliant fictional biography of Saint Teresa of </b><b>Ávila </b><b>breathes new life into a sacred subject” (<i>Booklist</i>).</b><br/>  <br/> She is Saint Teresa—known as a mystic, reformer, and founder of convents, and the author of numerous texts that introduced her radical religious ideas and practices to a society suffering through the repressive throes of the Spanish Inquisition. In Bárbara Mujica’s masterful tale, her story—her days of youthful romance, her sensual fits of spiritual rapture, secret heritage as a Jewish convert to Catholicism, cloak-and-dagger political dealings, struggles against sexual blackmail, and mysterious illness—unfolds with a tumultuous urgency. Blending fact with fiction in vivid detail, painstakingly researched and beautifully rendered, Mujica’s tale conjures a brilliant picture of sisterhood, faith, the terror of religious persecution, the miracle of salvation, and of one woman’s challenge to the power of strict orthodoxy, a challenge that consisted of a crime of passion—her own personal relationship with God.<br/>  <br/> “This engaging novel depicts Teresa of Ávila as an extraordinary woman whose visions, church reform ideas and writing may well have been inspired by God . . . Surprisingly light and entertaining.” —<i>Publishers Weekly</i><br/>  <br/> “A lifelong friend remembers Teresa of Ávila, ‘Spain’s most beloved saint,’ in this richly entertaining historical novel from Mujica . . . An earthy, humanizing portrait.” —<i>Kirkus Reviews</i> (starred review)<br/>  <br/> “Mujica brings this tumultuous time in history to vivid life. A very interesting and compelling novel which focuses more on Teresa’s entire life rather than simply her religion.” —Historical Novel Society
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bárbara Mujica
      </h2>
      
      <p class="authorDescription body article">B&aacute;rbara Mujica is a novelist, short story writer, critic, professor of Spanish at Georgetown University, and a contributor to many publications, such as the <I>New York Times</I> and the <I>Los Angeles Times</I>. She is the author of the novels <I>The Deaths of Don Bernardo</I>, <I>Frida</I>, and <I>Sister Teresa</I>, and lives in Washington, DC.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2ddcb1be